/** @jsxImportSource @emotion/react */
import React from 'react';
import { View } from 'react-native-web';
import { IProductCategory } from '@ddot/AddToCartCommon/lib/entities/ProductCategory';
import { useAppSelector } from 'Redux/hooks';
import NavActions from 'Services/Navigation/Actions';
import Selectors from '../../Redux/Selectors';
import {
    wrapper1,
    wrapper2,
    cont1,
    linkWrapper,
    linkText,
    GITItems,
} from '../Styles/FooterStyle';
import PackageJson from '../../../package.json';
import FooterMobile from './FooterMobile';

const Footer = (): JSX.Element => {
    const listProductsCategories = useAppSelector(Selectors.getProductsCategories);

    const navToProduct = () => {
        NavActions.navToProductListing();
    };

    const navToAbout = () => {
        NavActions.navToAboutUs();
    };

    const navCategories = (item: IProductCategory) => {
        NavActions.navToProductListingWithCategory(item.id);
    };

    return (
        <>
            <View className='footerWeb'>
                <div css={wrapper1}>
                    <div style={{ flex: 2, paddingTop: '5%' }}>
                        <div style={{ width: '30%' }}>
                            <img src='/Logo.png' alt='logo' style={{ height: '100%', width: '100%', objectFit: 'contain' }} />
                        </div>
                    </div>
                    <div css={cont1}>
                        <div style={{ flex: 4 }}>
                            <p style={{ color: '#8CB5C9', fontSize: '1.4rem' }}>All Pages</p>
                            <div css={linkWrapper}>
                                <div
                                    role='button'
                                    tabIndex={0}
                                    onClick={navToProduct}
                                    onKeyPress={navToProduct}
                                >
                                    <p>Products</p>
                                </div>

                                <a href={`${process.env.REACT_APP_BASE_URL_OLD}/about-us/`} rel='noreferrer'>
                                    <p>About Us</p>
                                </a>

                                <a href={`${process.env.REACT_APP_BASE_URL_OLD}/career/`} rel='noreferrer'>
                                    <p>Career</p>
                                </a>

                                <a href={`${process.env.REACT_APP_BASE_URL_OLD}/contact-us/`} rel='noreferrer'>
                                    <p>Contact Us</p>
                                </a>

                            </div>
                        </div>
                        <div style={{ flex: 4 }}>
                            <p style={{ color: '#8CB5C9', fontSize: '1.4rem' }}>Products</p>
                            <div css={linkWrapper}>
                                {
                                    listProductsCategories.map((item: IProductCategory) => {
                                        let nameOnly = item.name.split('- ').slice(1).join(' ').toLocaleLowerCase();

                                        if (nameOnly !== 'fine gold') {
                                            nameOnly = nameOnly.replace('gold', '');
                                        }

                                        if (nameOnly.length <= 2) {
                                            return null;
                                        }

                                        return (
                                            <div
                                                key={item.id}
                                                role='button'
                                                tabIndex={0}
                                                onClick={() => navCategories(item)}
                                                onKeyPress={() => navCategories(item)}
                                            >
                                                <p style={{ textTransform: 'capitalize' }}>{nameOnly}</p>
                                            </div>
                                        );
                                    })
                                }
                            </div>
                        </div>
                        <div style={{ flex: 4 }}>
                            <p style={{ color: '#8CB5C9', fontSize: '1.4rem' }}>Support</p>
                            <div css={linkWrapper}>
                                <a href={`${process.env.REACT_APP_BASE_URL_OLD}/faqs`} rel='noreferrer'><p>FAQs</p></a>
                                <a href={`${process.env.REACT_APP_BASE_URL_OLD}/shipping-returns`} rel='noreferrer'><p>Shipping & Returns</p></a>
                                <a href={`${process.env.REACT_APP_BASE_URL_OLD}/privacy-policy`} rel='noreferrer'><p>Privacy Policy</p></a>
                                <a href={`${process.env.REACT_APP_BASE_URL_OLD}/terms-of-service`} rel='noreferrer'><p>Terms of Service</p></a>
                            </div>
                        </div>
                        <div style={{ flex: 5 }}>
                            <p style={{ color: '#8CB5C9', fontSize: '1.4rem' }}>Get in Touch</p>
                            <div>
                                <div css={GITItems}>
                                    <img src='/assets/icons/Phone.png' alt='' style={{ height: 20, width: 20, marginTop: -3 }} />
                                    <p>75, Jalan Austin Heights 3, Taman Mount Austin, 81100 Johor Bahru, Johor, Malaysia.</p>
                                </div>
                                <div css={GITItems}>
                                    <img src='/assets/icons/location.png' alt='' style={{ height: 20, width: 20, marginTop: -3 }} />
                                    <p>+60 16-773 0338</p>
                                </div>
                                <div css={GITItems}>
                                    <img src='/assets/icons/mail.png' alt='' style={{ height: 20, width: 20, marginTop: -3 }} />
                                    <p>online@tiansi.my</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div css={wrapper2}>
                    <div style={{ display: 'flex', justifyContent: 'space-between', width: '100%' }}>
                        <p style={{ color: '#8CB5C9', fontFamily: 'AcuminRPro', fontSize: '1.1rem', margin: 0 }}>© 2024 Kedai Emas Tian Si Sdn. Bhd. (1100830-K) All Rights Reserved.</p>

                        <div style={{ display: 'flex', gap: 100 }}>
                            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                                <a href='https://tinyurl.com/TianSiJewellery' target='_blank' rel='noreferrer'>
                                    <p style={{ color: 'white', fontFamily: 'AcuminRPro', fontSize: '1.1rem', margin: 0 }}>TIANSI JEWELLERY</p>
                                </a>
                                <div style={{ display: 'flex', gap: 10 }}>
                                    <a href='https://tinyurl.com/TIANSI' target='_blank' rel='noreferrer' aria-label='visit facebook'>
                                        <img src='/assets/icons/Facebook1.svg' alt='' style={{ height: 20, width: 20 }} />
                                    </a>
                                    <a href='https://tinyurl.com/XHS-TianSiJewellery' target='_blank' rel='noreferrer' aria-label='visit xiaohongshu'>
                                        <img src='/assets/icons/XiaoHongShu1.svg' alt='' style={{ height: 20, width: 20 }} />
                                    </a>
                                    <a href='https://tinyurl.com/WAChannel-TianSiJewellery' target='_blank' rel='noreferrer' aria-label='visit whatsapp'>
                                        <img src='/assets/icons/whatsapp.png' alt='' style={{ height: 17, width: 17 }} />
                                    </a>
                                    <a href='https://tinyurl.com/ShopNow-TianSiJewellery' target='_blank' rel='noreferrer' aria-label='visit shop'>
                                        <img src='/assets/icons/shopping-bag.png' alt='' style={{ height: 18, width: 18 }} />
                                    </a>
                                    {/* <a href='https://www.youtube.com/@tiansijewellery4693' target='_blank' rel='noreferrer' aria-label='visit youtube'>
                                        <img src='/assets/icons/YouTube1.svg' alt='' style={{ height: 20, width: 20 }} />
                                    </a> */}
                                </div>
                            </div>

                            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                                <a href='https://tiansi.my/tiansi-hipine-gold-watch-malaysia/' target='_blank' rel='noreferrer'>
                                    <p style={{ color: 'white', fontFamily: 'AcuminRPro', fontSize: '1.1rem', margin: 0 }}>HIPINE MALAYSIA</p>
                                </a>
                                <div style={{ display: 'flex', gap: 10 }}>
                                    <a href='https://www.facebook.com/HIPINEMalaysia' target='_blank' rel='noreferrer' aria-label='visit facebook'>
                                        <img src='/assets/icons/Facebook1.svg' alt='' style={{ height: 20, width: 20 }} />
                                    </a>
                                    <a href='https://www.instagram.com/hipine_malaysia/' target='_blank' rel='noreferrer' aria-label='visit instagram'>
                                        <img src='/assets/icons/Instagram1.svg' alt='' style={{ height: 20, width: 20 }} />
                                    </a>
                                    <a href='https://www.xiaohongshu.com/user/profile/64db3109000000000100f95d?xsec_token=ABcNZezSzSbihVImV0ObtNmhIWBbUhHWChfChfLOrM8Jo%3D&xsec_source=pc_search' target='_blank' rel='noreferrer' aria-label='visit xiaohongshu'>
                                        <img src='/assets/icons/XiaoHongShu1.svg' alt='' style={{ height: 20, width: 20 }} />
                                    </a>
                                </div>
                            </div>

                            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                                <p style={{ color: 'white', fontFamily: 'AcuminRPro', fontSize: '1.1rem', margin: 0 }}>JIWA TUAH</p>
                                <div style={{ display: 'flex', gap: 10 }}>
                                    <a href='https://www.facebook.com/JiwaTuahMalaysia/' target='_blank' rel='noreferrer' aria-label='visit facebook'>
                                        <img src='/assets/icons/Facebook1.svg' alt='' style={{ height: 20, width: 20 }} />
                                    </a>
                                </div>
                            </div>
                        </div>
                        {/* <div style={{ display: 'flex', gap: 30 }}>
                            <p style={{ color: '#8CB5C9', fontFamily: 'AcuminRPro', fontSize: '1.1rem', margin: 0 }}>Connect with us</p>
                            <div style={{ display: 'flex', gap: 10 }}>
                                <a href='https://www.instagram.com/tiansi.jewellery/' target='_blank' rel='noreferrer' aria-label='visit instagram'>
                                    <img src='/assets/icons/Instagram1.svg' alt='' style={{ height: 20, width: 20 }} />
                                </a>
                                <a href='https://tinyurl.com/Facebook-TianSiJewellery' target='_blank' rel='noreferrer' aria-label='visit facebook'>
                                    <img src='/assets/icons/Facebook1.svg' alt='' style={{ height: 20, width: 20 }} />
                                </a>
                                <a href='https://www.tiktok.com/@tiansijewellery' target='_blank' rel='noreferrer' aria-label='visit tiktok'>
                                    <img src='/assets/icons/Tiktok1.svg' alt='' style={{ height: 20, width: 20 }} />
                                </a>
                                <a href='https://www.youtube.com/@tiansijewellery4693' target='_blank' rel='noreferrer' aria-label='visit youtube'>
                                    <img src='/assets/icons/YouTube1.svg' alt='' style={{ height: 20, width: 20 }} />
                                </a>
                                <a href='https://tinyurl.com/XHS-TianSiJewellery' target='_blank' rel='noreferrer' aria-label='visit xiaohongshu'>
                                    <img src='/assets/icons/XiaoHongShu1.svg' alt='' style={{ height: 20, width: 20 }} />
                                </a>
                            </div>
                        </div> */}
                    </div>
                </div>
            </View>

            <FooterMobile />
        </>

    );
};

export default Footer;
